function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.AdyenDocumentViewer = t() : e.AdyenDocumentViewer = t();
}(self, function () {
  return function () {
    var e = {
      184: function _(e, t) {
        var n;
        !function () {
          "use strict";

          var r = {}.hasOwnProperty;

          function o() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var n = arguments[t];

              if (n) {
                var i = _typeof(n);

                if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n)) {
                  if (n.length) {
                    var u = o.apply(null, n);
                    u && e.push(u);
                  }
                } else if ("object" === i) {
                  if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]")) {
                    e.push(n.toString());
                    continue;
                  }

                  for (var l in n) {
                    r.call(n, l) && n[l] && e.push(l);
                  }
                }
              }
            }

            return e.join(" ");
          }

          e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
            return o;
          }.apply(t, [])) || (e.exports = n);
        }();
      },
      533: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      136: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      727: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      73: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      544: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      874: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      857: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      498: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      280: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      557: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      461: function _(e, t, n) {
        "use strict";

        n.r(t);
      },
      400: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          Component: function Component() {
            return b;
          },
          Fragment: function Fragment() {
            return y;
          },
          cloneElement: function cloneElement() {
            return R;
          },
          createContext: function createContext() {
            return F;
          },
          createElement: function createElement() {
            return _h;
          },
          createRef: function createRef() {
            return m;
          },
          h: function h() {
            return _h;
          },
          hydrate: function hydrate() {
            return V;
          },
          isValidElement: function isValidElement() {
            return u;
          },
          options: function options() {
            return o;
          },
          render: function render() {
            return U;
          },
          toChildArray: function toChildArray() {
            return w;
          }
        });

        var r,
            o,
            i,
            u,
            l,
            _,
            a,
            c = {},
            s = [],
            f = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;

        function d(e, t) {
          for (var n in t) {
            e[n] = t[n];
          }

          return e;
        }

        function p(e) {
          var t = e.parentNode;
          t && t.removeChild(e);
        }

        function _h(e, t, n) {
          var o,
              i,
              u,
              l = {};

          for (u in t) {
            "key" == u ? o = t[u] : "ref" == u ? i = t[u] : l[u] = t[u];
          }

          if (arguments.length > 2 && (l.children = arguments.length > 3 ? r.call(arguments, 2) : n), "function" == typeof e && null != e.defaultProps) for (u in e.defaultProps) {
            void 0 === l[u] && (l[u] = e.defaultProps[u]);
          }
          return v(e, l, o, i, null);
        }

        function v(e, t, n, r, u) {
          var l = {
            type: e,
            props: t,
            key: n,
            ref: r,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == u ? ++i : u
          };
          return null == u && null != o.vnode && o.vnode(l), l;
        }

        function m() {
          return {
            current: null
          };
        }

        function y(e) {
          return e.children;
        }

        function b(e, t) {
          this.props = e, this.context = t;
        }

        function g(e, t) {
          if (null == t) return e.__ ? g(e.__, e.__.__k.indexOf(e) + 1) : null;

          for (var n; t < e.__k.length; t++) {
            if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
          }

          return "function" == typeof e.type ? g(e) : null;
        }

        function x(e) {
          var t, n;

          if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) {
              if (null != (n = e.__k[t]) && null != n.__e) {
                e.__e = e.__c.base = n.__e;
                break;
              }
            }

            return x(e);
          }
        }

        function k(e) {
          (!e.__d && (e.__d = !0) && l.push(e) && !E.__r++ || _ !== o.debounceRendering) && ((_ = o.debounceRendering) || setTimeout)(E);
        }

        function E() {
          for (var e; E.__r = l.length;) {
            e = l.sort(function (e, t) {
              return e.__v.__b - t.__v.__b;
            }), l = [], e.some(function (e) {
              var t, n, r, o, i, u;
              e.__d && (i = (o = (t = e).__v).__e, (u = t.__P) && (n = [], (r = d({}, o)).__v = o.__v + 1, j(u, o, r, t.__n, void 0 !== u.ownerSVGElement, null != o.__h ? [i] : null, n, null == i ? g(o) : i, o.__h), D(n, o), o.__e != i && x(o)));
            });
          }
        }

        function P(e, t, n, r, o, i, u, l, _, a) {
          var f,
              d,
              p,
              h,
              m,
              b,
              x,
              k = r && r.__k || s,
              E = k.length;

          for (n.__k = [], f = 0; f < t.length; f++) {
            if (null != (h = n.__k[f] = null == (h = t[f]) || "boolean" == typeof h ? null : "string" == typeof h || "number" == typeof h || "bigint" == typeof h ? v(null, h, null, null, h) : Array.isArray(h) ? v(y, {
              children: h
            }, null, null, null) : h.__b > 0 ? v(h.type, h.props, h.key, h.ref ? h.ref : null, h.__v) : h)) {
              if (h.__ = n, h.__b = n.__b + 1, null === (p = k[f]) || p && h.key == p.key && h.type === p.type) k[f] = void 0;else for (d = 0; d < E; d++) {
                if ((p = k[d]) && h.key == p.key && h.type === p.type) {
                  k[d] = void 0;
                  break;
                }

                p = null;
              }
              j(e, h, p = p || c, o, i, u, l, _, a), m = h.__e, (d = h.ref) && p.ref != d && (x || (x = []), p.ref && x.push(p.ref, null, h), x.push(d, h.__c || m, h)), null != m ? (null == b && (b = m), "function" == typeof h.type && h.__k === p.__k ? h.__d = _ = M(h, _, e) : _ = N(e, h, p, k, m, _), "function" == typeof n.type && (n.__d = _)) : _ && p.__e == _ && _.parentNode != e && (_ = g(p));
            }
          }

          for (n.__e = b, f = E; f--;) {
            null != k[f] && L(k[f], k[f]);
          }

          if (x) for (f = 0; f < x.length; f++) {
            H(x[f], x[++f], x[++f]);
          }
        }

        function M(e, t, n) {
          for (var r, o = e.__k, i = 0; o && i < o.length; i++) {
            (r = o[i]) && (r.__ = e, t = "function" == typeof r.type ? M(r, t, n) : N(n, r, r, o, r.__e, t));
          }

          return t;
        }

        function w(e, t) {
          return t = t || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some(function (e) {
            w(e, t);
          }) : t.push(e)), t;
        }

        function N(e, t, n, r, o, i) {
          var u, l, _;

          if (void 0 !== t.__d) u = t.__d, t.__d = void 0;else if (null == n || o != i || null == o.parentNode) e: if (null == i || i.parentNode !== e) e.appendChild(o), u = null;else {
            for (l = i, _ = 0; (l = l.nextSibling) && _ < r.length; _ += 1) {
              if (l == o) break e;
            }

            e.insertBefore(o, i), u = i;
          }
          return void 0 !== u ? u : o.nextSibling;
        }

        function S(e, t, n) {
          "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || f.test(t) ? n : n + "px";
        }

        function O(e, t, n, r, o) {
          var i;

          e: if ("style" === t) {
            if ("string" == typeof n) e.style.cssText = n;else {
              if ("string" == typeof r && (e.style.cssText = r = ""), r) for (t in r) {
                n && t in n || S(e.style, t, "");
              }
              if (n) for (t in n) {
                r && n[t] === r[t] || S(e.style, t, n[t]);
              }
            }
          } else if ("o" === t[0] && "n" === t[1]) i = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + i] = n, n ? r || e.addEventListener(t, i ? C : T, i) : e.removeEventListener(t, i ? C : T, i);else if ("dangerouslySetInnerHTML" !== t) {
            if (o) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
              e[t] = null == n ? "" : n;
              break e;
            } catch (e) {}
            "function" == typeof n || (null == n || !1 === n && -1 == t.indexOf("-") ? e.removeAttribute(t) : e.setAttribute(t, n));
          }
        }

        function T(e) {
          this.l[e.type + !1](o.event ? o.event(e) : e);
        }

        function C(e) {
          this.l[e.type + !0](o.event ? o.event(e) : e);
        }

        function j(e, t, n, r, i, u, l, _, a) {
          var c,
              s,
              f,
              p,
              h,
              v,
              m,
              g,
              x,
              k,
              E,
              M,
              w,
              N,
              S,
              O = t.type;
          if (void 0 !== t.constructor) return null;
          null != n.__h && (a = n.__h, _ = t.__e = n.__e, t.__h = null, u = [_]), (c = o.__b) && c(t);

          try {
            e: if ("function" == typeof O) {
              if (g = t.props, x = (c = O.contextType) && r[c.__c], k = c ? x ? x.props.value : c.__ : r, n.__c ? m = (s = t.__c = n.__c).__ = s.__E : ("prototype" in O && O.prototype.render ? t.__c = s = new O(g, k) : (t.__c = s = new b(g, k), s.constructor = O, s.render = I), x && x.sub(s), s.props = g, s.state || (s.state = {}), s.context = k, s.__n = r, f = s.__d = !0, s.__h = [], s._sb = []), null == s.__s && (s.__s = s.state), null != O.getDerivedStateFromProps && (s.__s == s.state && (s.__s = d({}, s.__s)), d(s.__s, O.getDerivedStateFromProps(g, s.__s))), p = s.props, h = s.state, f) null == O.getDerivedStateFromProps && null != s.componentWillMount && s.componentWillMount(), null != s.componentDidMount && s.__h.push(s.componentDidMount);else {
                if (null == O.getDerivedStateFromProps && g !== p && null != s.componentWillReceiveProps && s.componentWillReceiveProps(g, k), !s.__e && null != s.shouldComponentUpdate && !1 === s.shouldComponentUpdate(g, s.__s, k) || t.__v === n.__v) {
                  for (s.props = g, s.state = s.__s, t.__v !== n.__v && (s.__d = !1), s.__v = t, t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function (e) {
                    e && (e.__ = t);
                  }), E = 0; E < s._sb.length; E++) {
                    s.__h.push(s._sb[E]);
                  }

                  s._sb = [], s.__h.length && l.push(s);
                  break e;
                }

                null != s.componentWillUpdate && s.componentWillUpdate(g, s.__s, k), null != s.componentDidUpdate && s.__h.push(function () {
                  s.componentDidUpdate(p, h, v);
                });
              }

              if (s.context = k, s.props = g, s.__v = t, s.__P = e, M = o.__r, w = 0, "prototype" in O && O.prototype.render) {
                for (s.state = s.__s, s.__d = !1, M && M(t), c = s.render(s.props, s.state, s.context), N = 0; N < s._sb.length; N++) {
                  s.__h.push(s._sb[N]);
                }

                s._sb = [];
              } else do {
                s.__d = !1, M && M(t), c = s.render(s.props, s.state, s.context), s.state = s.__s;
              } while (s.__d && ++w < 25);

              s.state = s.__s, null != s.getChildContext && (r = d(d({}, r), s.getChildContext())), f || null == s.getSnapshotBeforeUpdate || (v = s.getSnapshotBeforeUpdate(p, h)), S = null != c && c.type === y && null == c.key ? c.props.children : c, P(e, Array.isArray(S) ? S : [S], t, n, r, i, u, l, _, a), s.base = t.__e, t.__h = null, s.__h.length && l.push(s), m && (s.__E = s.__ = null), s.__e = !1;
            } else null == u && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = A(n.__e, t, n, r, i, u, l, a);

            (c = o.diffed) && c(t);
          } catch (e) {
            t.__v = null, (a || null != u) && (t.__e = _, t.__h = !!a, u[u.indexOf(_)] = null), o.__e(e, t, n);
          }
        }

        function D(e, t) {
          o.__c && o.__c(t, e), e.some(function (t) {
            try {
              e = t.__h, t.__h = [], e.some(function (e) {
                e.call(t);
              });
            } catch (e) {
              o.__e(e, t.__v);
            }
          });
        }

        function A(e, t, n, o, i, u, l, _) {
          var a,
              s,
              f,
              d = n.props,
              h = t.props,
              v = t.type,
              m = 0;
          if ("svg" === v && (i = !0), null != u) for (; m < u.length; m++) {
            if ((a = u[m]) && "setAttribute" in a == !!v && (v ? a.localName === v : 3 === a.nodeType)) {
              e = a, u[m] = null;
              break;
            }
          }

          if (null == e) {
            if (null === v) return document.createTextNode(h);
            e = i ? document.createElementNS("http://www.w3.org/2000/svg", v) : document.createElement(v, h.is && h), u = null, _ = !1;
          }

          if (null === v) d === h || _ && e.data === h || (e.data = h);else {
            if (u = u && r.call(e.childNodes), s = (d = n.props || c).dangerouslySetInnerHTML, f = h.dangerouslySetInnerHTML, !_) {
              if (null != u) for (d = {}, m = 0; m < e.attributes.length; m++) {
                d[e.attributes[m].name] = e.attributes[m].value;
              }
              (f || s) && (f && (s && f.__html == s.__html || f.__html === e.innerHTML) || (e.innerHTML = f && f.__html || ""));
            }

            if (function (e, t, n, r, o) {
              var i;

              for (i in n) {
                "children" === i || "key" === i || i in t || O(e, i, null, n[i], r);
              }

              for (i in t) {
                o && "function" != typeof t[i] || "children" === i || "key" === i || "value" === i || "checked" === i || n[i] === t[i] || O(e, i, t[i], n[i], r);
              }
            }(e, h, d, i, _), f) t.__k = [];else if (m = t.props.children, P(e, Array.isArray(m) ? m : [m], t, n, o, i && "foreignObject" !== v, u, l, u ? u[0] : n.__k && g(n, 0), _), null != u) for (m = u.length; m--;) {
              null != u[m] && p(u[m]);
            }
            _ || ("value" in h && void 0 !== (m = h.value) && (m !== e.value || "progress" === v && !m || "option" === v && m !== d.value) && O(e, "value", m, d.value, !1), "checked" in h && void 0 !== (m = h.checked) && m !== e.checked && O(e, "checked", m, d.checked, !1));
          }
          return e;
        }

        function H(e, t, n) {
          try {
            "function" == typeof e ? e(t) : e.current = t;
          } catch (e) {
            o.__e(e, n);
          }
        }

        function L(e, t, n) {
          var r, i;

          if (o.unmount && o.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || H(r, null, t)), null != (r = e.__c)) {
            if (r.componentWillUnmount) try {
              r.componentWillUnmount();
            } catch (e) {
              o.__e(e, t);
            }
            r.base = r.__P = null, e.__c = void 0;
          }

          if (r = e.__k) for (i = 0; i < r.length; i++) {
            r[i] && L(r[i], t, n || "function" != typeof e.type);
          }
          n || null == e.__e || p(e.__e), e.__ = e.__e = e.__d = void 0;
        }

        function I(e, t, n) {
          return this.constructor(e, n);
        }

        function U(e, t, n) {
          var i, u, l;
          o.__ && o.__(e, t), u = (i = "function" == typeof n) ? null : n && n.__k || t.__k, l = [], j(t, e = (!i && n || t).__k = _h(y, null, [e]), u || c, c, void 0 !== t.ownerSVGElement, !i && n ? [n] : u ? null : t.firstChild ? r.call(t.childNodes) : null, l, !i && n ? n : u ? u.__e : t.firstChild, i), D(l, e);
        }

        function V(e, t) {
          U(e, t, V);
        }

        function R(e, t, n) {
          var o,
              i,
              u,
              l = d({}, e.props);

          for (u in t) {
            "key" == u ? o = t[u] : "ref" == u ? i = t[u] : l[u] = t[u];
          }

          return arguments.length > 2 && (l.children = arguments.length > 3 ? r.call(arguments, 2) : n), v(e.type, l, o || e.key, i || e.ref, null);
        }

        function F(e, t) {
          var n = {
            __c: t = "__cC" + a++,
            __: e,
            Consumer: function Consumer(e, t) {
              return e.children(t);
            },
            Provider: function Provider(e) {
              var n, r;
              return this.getChildContext || (n = [], (r = {})[t] = this, this.getChildContext = function () {
                return r;
              }, this.shouldComponentUpdate = function (e) {
                this.props.value !== e.value && n.some(k);
              }, this.sub = function (e) {
                n.push(e);
                var t = e.componentWillUnmount;

                e.componentWillUnmount = function () {
                  n.splice(n.indexOf(e), 1), t && t.call(e);
                };
              }), e.children;
            }
          };
          return n.Provider.__ = n.Consumer.contextType = n;
        }

        r = s.slice, o = {
          __e: function __e(e, t, n, r) {
            for (var o, i, u; t = t.__;) {
              if ((o = t.__c) && !o.__) try {
                if ((i = o.constructor) && null != i.getDerivedStateFromError && (o.setState(i.getDerivedStateFromError(e)), u = o.__d), null != o.componentDidCatch && (o.componentDidCatch(e, r || {}), u = o.__d), u) return o.__E = o;
              } catch (t) {
                e = t;
              }
            }

            throw e;
          }
        }, i = 0, u = function u(e) {
          return null != e && void 0 === e.constructor;
        }, b.prototype.setState = function (e, t) {
          var n;
          n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = d({}, this.state), "function" == typeof e && (e = e(d({}, n), this.props)), e && d(n, e), null != e && this.__v && (t && this._sb.push(t), k(this));
        }, b.prototype.forceUpdate = function (e) {
          this.__v && (this.__e = !0, e && this.__h.push(e), k(this));
        }, b.prototype.render = y, l = [], E.__r = 0, a = 0;
      },
      396: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          useCallback: function useCallback() {
            return P;
          },
          useContext: function useContext() {
            return M;
          },
          useDebugValue: function useDebugValue() {
            return w;
          },
          useEffect: function useEffect() {
            return b;
          },
          useErrorBoundary: function useErrorBoundary() {
            return N;
          },
          useId: function useId() {
            return S;
          },
          useImperativeHandle: function useImperativeHandle() {
            return k;
          },
          useLayoutEffect: function useLayoutEffect() {
            return g;
          },
          useMemo: function useMemo() {
            return E;
          },
          useReducer: function useReducer() {
            return y;
          },
          useRef: function useRef() {
            return x;
          },
          useState: function useState() {
            return m;
          }
        });
        var r,
            o,
            i,
            u,
            l = n(400),
            _ = 0,
            a = [],
            c = [],
            s = l.options.__b,
            f = l.options.__r,
            d = l.options.diffed,
            p = l.options.__c,
            h = l.options.unmount;

        function v(e, t) {
          l.options.__h && l.options.__h(o, e, _ || t), _ = 0;
          var n = o.__H || (o.__H = {
            __: [],
            __h: []
          });
          return e >= n.__.length && n.__.push({
            __V: c
          }), n.__[e];
        }

        function m(e) {
          return _ = 1, y(H, e);
        }

        function y(e, t, n) {
          var i = v(r++, 2);

          if (i.t = e, !i.__c && (i.__ = [n ? n(t) : H(void 0, t), function (e) {
            var t = i.__N ? i.__N[0] : i.__[0],
                n = i.t(t, e);
            t !== n && (i.__N = [n, i.__[1]], i.__c.setState({}));
          }], i.__c = o, !o.u)) {
            o.u = !0;
            var u = o.shouldComponentUpdate;

            o.shouldComponentUpdate = function (e, t, n) {
              if (!i.__c.__H) return !0;

              var r = i.__c.__H.__.filter(function (e) {
                return e.__c;
              });

              if (r.every(function (e) {
                return !e.__N;
              })) return !u || u.call(this, e, t, n);
              var o = !1;
              return r.forEach(function (e) {
                if (e.__N) {
                  var t = e.__[0];
                  e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0);
                }
              }), !(!o && i.__c.props === e) && (!u || u.call(this, e, t, n));
            };
          }

          return i.__N || i.__;
        }

        function b(e, t) {
          var n = v(r++, 3);
          !l.options.__s && A(n.__H, t) && (n.__ = e, n.i = t, o.__H.__h.push(n));
        }

        function g(e, t) {
          var n = v(r++, 4);
          !l.options.__s && A(n.__H, t) && (n.__ = e, n.i = t, o.__h.push(n));
        }

        function x(e) {
          return _ = 5, E(function () {
            return {
              current: e
            };
          }, []);
        }

        function k(e, t, n) {
          _ = 6, g(function () {
            return "function" == typeof e ? (e(t()), function () {
              return e(null);
            }) : e ? (e.current = t(), function () {
              return e.current = null;
            }) : void 0;
          }, null == n ? n : n.concat(e));
        }

        function E(e, t) {
          var n = v(r++, 7);
          return A(n.__H, t) ? (n.__V = e(), n.i = t, n.__h = e, n.__V) : n.__;
        }

        function P(e, t) {
          return _ = 8, E(function () {
            return e;
          }, t);
        }

        function M(e) {
          var t = o.context[e.__c],
              n = v(r++, 9);
          return n.c = e, t ? (null == n.__ && (n.__ = !0, t.sub(o)), t.props.value) : e.__;
        }

        function w(e, t) {
          l.options.useDebugValue && l.options.useDebugValue(t ? t(e) : e);
        }

        function N(e) {
          var t = v(r++, 10),
              n = m();
          return t.__ = e, o.componentDidCatch || (o.componentDidCatch = function (e, r) {
            t.__ && t.__(e, r), n[1](e);
          }), [n[0], function () {
            n[1](void 0);
          }];
        }

        function S() {
          var e = v(r++, 11);

          if (!e.__) {
            for (var t = o.__v; null !== t && !t.__m && null !== t.__;) {
              t = t.__;
            }

            var n = t.__m || (t.__m = [0, 0]);
            e.__ = "P" + n[0] + "-" + n[1]++;
          }

          return e.__;
        }

        function O() {
          for (var e; e = a.shift();) {
            if (e.__P && e.__H) try {
              e.__H.__h.forEach(j), e.__H.__h.forEach(D), e.__H.__h = [];
            } catch (t) {
              e.__H.__h = [], l.options.__e(t, e.__v);
            }
          }
        }

        l.options.__b = function (e) {
          o = null, s && s(e);
        }, l.options.__r = function (e) {
          f && f(e), r = 0;
          var t = (o = e.__c).__H;
          t && (i === o ? (t.__h = [], o.__h = [], t.__.forEach(function (e) {
            e.__N && (e.__ = e.__N), e.__V = c, e.__N = e.i = void 0;
          })) : (t.__h.forEach(j), t.__h.forEach(D), t.__h = [])), i = o;
        }, l.options.diffed = function (e) {
          d && d(e);
          var t = e.__c;
          t && t.__H && (t.__H.__h.length && (1 !== a.push(t) && u === l.options.requestAnimationFrame || ((u = l.options.requestAnimationFrame) || C)(O)), t.__H.__.forEach(function (e) {
            e.i && (e.__H = e.i), e.__V !== c && (e.__ = e.__V), e.i = void 0, e.__V = c;
          })), i = o = null;
        }, l.options.__c = function (e, t) {
          t.some(function (e) {
            try {
              e.__h.forEach(j), e.__h = e.__h.filter(function (e) {
                return !e.__ || D(e);
              });
            } catch (n) {
              t.some(function (e) {
                e.__h && (e.__h = []);
              }), t = [], l.options.__e(n, e.__v);
            }
          }), p && p(e, t);
        }, l.options.unmount = function (e) {
          h && h(e);
          var t,
              n = e.__c;
          n && n.__H && (n.__H.__.forEach(function (e) {
            try {
              j(e);
            } catch (e) {
              t = e;
            }
          }), n.__H = void 0, t && l.options.__e(t, n.__v));
        };
        var T = "function" == typeof requestAnimationFrame;

        function C(e) {
          var t,
              n = function n() {
            clearTimeout(r), T && cancelAnimationFrame(t), setTimeout(e);
          },
              r = setTimeout(n, 100);

          T && (t = requestAnimationFrame(n));
        }

        function j(e) {
          var t = o,
              n = e.__c;
          "function" == typeof n && (e.__c = void 0, n()), o = t;
        }

        function D(e) {
          var t = o;
          e.__c = e.__(), o = t;
        }

        function A(e, t) {
          return !e || e.length !== t.length || t.some(function (t, n) {
            return t !== e[n];
          });
        }

        function H(e, t) {
          return "function" == typeof t ? t(e) : t;
        }
      },
      212: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400);
        n(533);

        var i = r(n(184)),
            u = r(n(527)),
            l = r(n(571)),
            _ = r(n(651));

        t.default = function (e) {
          var t = e.document,
              n = e.className,
              r = e.onExpandSection,
              a = (0, i.default)("adyen-document-viewer", n);
          return (0, o.h)("div", {
            className: a
          }, (0, o.h)(u.default, {
            level: 1,
            className: "adv-u-margin-top-24 adv-u-margin-bottom-16"
          }, (0, o.h)(l.default, {
            content: t.title.content,
            styles: t.title.styles
          })), (0, o.h)(_.default, {
            contentElements: t.contentElements,
            onExpandSection: r,
            isTopLevel: !0
          }));
        };
      },
      813: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = n(396),
            u = r(n(184)),
            l = n(669);
        n(136), t.default = function (e) {
          var t = e.children,
              n = e.className,
              r = e.expand,
              _ = void 0 !== r && r,
              a = e.type,
              c = e.onExpandSection,
              s = (0, i.useState)([]),
              f = s[0],
              d = s[1],
              p = (0, u.default)("adv-accordion", n, {
            "adv-accordion--container": "container" === a
          });

          return (0, o.h)(l.AccordionContext.Provider, {
            value: {
              expand: _,
              items: f,
              setItems: d,
              onExpandSection: c
            }
          }, (0, o.h)("div", {
            className: p
          }, t));
        };
      },
      669: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.AccordionContext = void 0;
        var r = n(400);
        t.AccordionContext = (0, r.createContext)(null);
      },
      666: function _(e, t, n) {
        "use strict";

        var r = this && this.__assign || function () {
          return r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }, r.apply(this, arguments);
        },
            o = this && this.__spreadArray || function (e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) {
            !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          }
          return e.concat(r || Array.prototype.slice.call(t));
        },
            i = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var u = n(400),
            l = i(n(682)),
            _ = i(n(936)),
            a = i(n(535)),
            c = n(578),
            s = n(396);

        n(727), t.default = function (e) {
          var t = e.children,
              n = e.open,
              i = void 0 !== n && n,
              f = e.title,
              d = void 0 === f ? "" : f,
              p = (0, l.default)(),
              h = p.expand,
              v = p.items,
              m = p.setItems,
              y = p.onExpandSection,
              b = (0, s.useState)(i),
              g = b[0],
              x = b[1],
              k = (0, s.useState)(c.getUniqueId)[0];
          return (0, s.useEffect)(function () {
            m(function (e) {
              return o(o([], e, !0), [{
                id: k,
                isOpen: g
              }], !1);
            });
          }, []), (0, s.useEffect)(function () {
            x(i);
          }, [i]), (0, s.useEffect)(function () {
            var e;
            x(null === (e = v.find(function (e) {
              return e.id === k;
            })) || void 0 === e ? void 0 : e.isOpen);
          }, [v]), (0, s.useEffect)(function () {
            g && (null == y || y(d));
          }, [g]), (0, u.h)("div", {
            className: "adv-accordion__item"
          }, (0, u.h)("div", {
            role: "button",
            className: "adv-accordion__header",
            tabIndex: 0,
            onClick: function onClick() {
              var e = !g,
                  t = o([], v, !0);
              h ? (t.find(function (e) {
                return e.id === k;
              }).isOpen = e, m(t)) : m(t.map(function (t) {
                return r(r({}, t), {
                  isOpen: t.id === k && e
                });
              }));
            }
          }, (0, u.h)(a.default, {
            name: g ? "chevron-up" : "chevron-down",
            className: "adv-accordion__toggle"
          }), (0, u.h)("div", {
            className: "adv-accordion__title-wrapper"
          }, (0, u.h)("div", {
            className: "adv-accordion__title"
          }, d))), (0, u.h)(_.default, {
            collapsed: !g
          }, (0, u.h)("div", {
            className: "adv-accordion__content"
          }, t)));
        };
      },
      682: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(396),
            o = n(669);

        t.default = function () {
          return (0, r.useContext)(o.AccordionContext);
        };
      },
      473: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(527)),
            u = r(n(571)),
            l = r(n(651));

        t.default = function (e) {
          var t = e.title,
              n = e.contentElements;
          return (0, o.h)("section", {
            className: "adv-u-margin-bottom-48"
          }, (0, o.h)(i.default, {
            level: 2,
            className: "adv-u-margin-top-24 adv-u-margin-bottom-16"
          }, (0, o.h)(u.default, {
            content: t.content,
            styles: t.styles
          })), (0, o.h)(l.default, {
            contentElements: n,
            isTopLevel: !0
          }));
        };
      },
      936: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(400),
            o = n(396);
        n(73), t.default = function (e) {
          var t = e.children,
              n = e.collapsed,
              i = void 0 !== n && n,
              u = (0, o.useRef)(null),
              l = (0, o.useState)(i ? 0 : void 0),
              _ = l[0],
              a = l[1];
          return (0, o.useEffect)(function () {
            var e;
            a(i ? 0 : null === (e = u.current) || void 0 === e ? void 0 : e.scrollHeight);
          }, [i]), (0, r.h)("div", {
            className: "adv-collapsible-container",
            "aria-hidden": i,
            ref: u,
            style: {
              height: _
            }
          }, t);
        };
      },
      651: function _(e, t, n) {
        "use strict";

        var r = this && this.__assign || function () {
          return r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }, r.apply(this, arguments);
        },
            o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var i = n(400),
            u = n(230),
            l = n(578),
            _ = o(n(813)),
            a = o(n(473)),
            c = o(n(4)),
            s = o(n(601)),
            f = o(n(571)),
            d = o(n(273)),
            p = o(n(947)),
            h = o(n(420)),
            v = o(n(545));

        t.default = function (e) {
          var t = e.contentElements,
              n = e.isTopLevel,
              o = void 0 !== n && n,
              m = e.onExpandSection,
              y = {
            chapter: a.default,
            section: c.default,
            paragraph: s.default,
            text: f.default,
            weblink: d.default,
            list: p.default,
            table: h.default,
            internalReference: v.default,
            breakline: "br"
          },
              b = t.map(function (e) {
            var t,
                n = y[e.type];
            return (0, i.h)(n, r({
              key: (t = e.type, "key-".concat(t, "-").concat((0, l.getUniqueId)()))
            }, function (e) {
              switch (e.type) {
                case u.ElementTypes.Chapter:
                  return {
                    title: e.title,
                    contentElements: e.contentElements
                  };

                case u.ElementTypes.Section:
                  return {
                    isTopLevel: o,
                    title: e.title,
                    label: e.label,
                    contentElements: e.contentElements
                  };

                case u.ElementTypes.Paragraph:
                  return {
                    isTopLevel: o,
                    contentElements: e.contentElements
                  };

                case u.ElementTypes.Text:
                  return {
                    content: e.content,
                    styles: e.styles
                  };

                case u.ElementTypes.Weblink:
                  return {
                    url: e.url,
                    displayText: e.displayText
                  };

                case u.ElementTypes.List:
                  return {
                    items: e.items,
                    style: e.style
                  };

                case u.ElementTypes.Table:
                  return {
                    rows: e.rows,
                    label: e.label,
                    captions: e.captions,
                    titlePrefix: e.titlePrefix,
                    title: e.title
                  };

                case u.ElementTypes.InternalReference:
                  return {
                    referencedLabel: e.referencedLabel,
                    displayText: e.displayText
                  };

                default:
                  return null;
              }
            }(e)));
          });
          return o ? (0, i.h)(_.default, {
            onExpandSection: m,
            expand: !0
          }, b) : (0, i.h)("span", null, b);
        };
      },
      527: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(184));
        n(544);
        var u = {
          1: "h1",
          2: "h2"
        };

        t.default = function (e) {
          var t = e.className,
              n = e.level,
              r = e.children,
              l = u[n] || u[1],
              _ = (0, i.default)("adv-heading", "adv-heading--".concat(n), t);

          return (0, o.createElement)(l, {
            className: _
          }, r);
        };
      },
      535: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(184));
        n(874);

        t.default = function (e) {
          var t = e.className,
              n = void 0 === t ? "" : t,
              r = e.name,
              u = {
            "chevron-up": (0, o.h)("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 15 15",
              width: "15",
              height: "15"
            }, (0, o.h)("path", {
              fillRule: "evenodd",
              d: "M13 10a1 1 0 0 1-1.743.669L7.5 6.495 3.743 10.67a1 1 0 0 1-1.486-1.338l4.5-5a1 1 0 0 1 1.486 0l4.5 5a.998.998 0 0 1 .257.67z"
            })),
            "chevron-down": (0, o.h)("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 15 15",
              width: "15",
              height: "15"
            }, (0, o.h)("path", {
              fillRule: "evenodd",
              d: "M2 5a1 1 0 0 1 1.743-.669L7.5 8.505l3.757-4.174a1 1 0 0 1 1.486 1.338l-4.5 5a1 1 0 0 1-1.486 0l-4.5-5A.998.998 0 0 1 2 4.999z"
            }))
          };
          return (0, o.h)("i", {
            className: (0, i.default)("adv-icon", n),
            role: "img",
            "aria-hidden": !0
          }, u[r]);
        };
      },
      545: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(893)),
            u = n(70);

        t.default = function (e) {
          var t = e.referencedLabel,
              n = e.displayText,
              r = n ? n.content : t;
          return (0, o.h)(i.default, {
            onClick: function onClick() {
              var e = (0, u.getScrollParent)(document.getElementById(t)),
                  n = -1 !== e && e.querySelector("#" + t);
              null == n || n.scrollIntoView({
                behavior: "smooth"
              });
            },
            label: r
          });
        };
      },
      995: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(184));
        n(857);

        t.default = function (e) {
          var t = e.className,
              n = e.children,
              r = e.href,
              u = e.underline,
              l = e.inheritStyles,
              _ = e.onClick,
              a = (0, i.default)("adv-link", t, {
            "adv-link--underline": u,
            "adv-link--inherit": l
          });
          return (0, o.h)("a", {
            href: r,
            className: a,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: _
          }, (0, o.h)("span", {
            className: "adv-link__text"
          }, n));
        };
      },
      893: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(400);
        n(857);

        t.default = function (e) {
          var t = e.onClick,
              n = e.label;
          return (0, r.h)("button", {
            className: "adv-link",
            type: "button",
            onClick: t
          }, n);
        };
      },
      35: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(184));
        n(498), t.default = function (e) {
          var t = e.className,
              n = e.nested,
              r = e.ordered,
              u = e.noMarkers,
              l = e.children,
              _ = (0, i.default)(["adv-list", n && "adv-list--nested", r && "adv-list--ordered", u && "adv-list--no-markers", t]);

          return (0, o.h)("ul", {
            className: _
          }, l);
        };
      },
      931: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(184));

        t.default = function (e) {
          var t = e.className,
              n = e.children,
              r = e.noMarkers,
              u = (0, i.default)(["adv-list__item", r && "adv-list__item--no-markers", t]);
          return (0, o.h)("li", {
            className: u
          }, n);
        };
      },
      947: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(35)),
            u = r(n(931)),
            l = r(n(651));

        t.default = function e(t) {
          var n = t.items,
              r = t.style;
          return (0, o.h)(i.default, {
            ordered: r.ordered
          }, n.map(function (t, n) {
            return (0, o.h)(u.default, {
              key: n
            }, (0, o.h)(l.default, {
              contentElements: t.content
            }), t.subList && (0, o.h)(e, {
              style: t.subList.style,
              items: t.subList.items
            }));
          }));
        };
      },
      601: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(651)),
            u = r(n(184));
        n(280), t.default = function (e) {
          var t = e.isTopLevel,
              n = e.contentElements,
              r = (0, u.default)("adv-paragraph", {
            "adv-u-margin-bottom-16": t
          });
          return (0, o.h)("p", {
            className: r
          }, (0, o.h)(i.default, {
            contentElements: n
          }));
        };
      },
      4: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = r(n(527)),
            u = r(n(571));
        n(557);

        var l = r(n(666)),
            _ = r(n(651));

        t.default = function (e) {
          var t = e.title,
              n = e.label,
              r = e.isTopLevel,
              a = e.contentElements;
          return r ? (0, o.h)(l.default, {
            title: t.content
          }, (0, o.h)("section", {
            className: "adv-section-box",
            id: n
          }, (0, o.h)(_.default, {
            contentElements: a
          }))) : (0, o.h)("section", {
            id: n
          }, (0, o.h)(i.default, {
            level: 2,
            className: "adv-u-margin-top-24 adv-u-margin-bottom-16"
          }, (0, o.h)(u.default, {
            content: t.content,
            styles: t.styles
          })), (0, o.h)(_.default, {
            contentElements: a
          }));
        };
      },
      420: function _(e, t, n) {
        "use strict";

        var r = this && this.__assign || function () {
          return r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }, r.apply(this, arguments);
        },
            o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = n(400),
            u = o(n(571)),
            l = o(n(651));
        n(461), t.default = function (e) {
          var t = e.rows,
              n = e.label,
              o = e.captions,
              _ = e.titlePrefix,
              a = e.title;
          return (0, i.h)("div", {
            id: n
          }, (0, i.h)("div", {
            className: "adv-u-margin-y-8 adv-u-text-align-center"
          }, _ && (0, i.h)(u.default, r({}, _)), a && (0, i.h)(u.default, r({}, a))), (0, i.h)("table", {
            className: "adv-table adv-table--condensed"
          }, o && (0, i.h)("caption", null, (0, i.h)(l.default, {
            contentElements: o
          })), (0, i.h)("tbody", {
            className: "adv-table__body"
          }, t.map(function (e, t) {
            return (0, i.h)("tr", {
              key: t,
              className: "adv-table__row"
            }, e.map(function (e, t) {
              return (0, i.h)("td", {
                key: t,
                className: "adv-table__cell"
              }, (0, i.h)(l.default, {
                contentElements: e.elements
              }));
            }));
          }))));
        };
      },
      571: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(400),
            i = n(230),
            u = r(n(184));

        t.default = function (e) {
          var t = e.content,
              n = e.styles,
              r = (0, u.default)({
            "adv-u-font-weight-semi-bold": null == n ? void 0 : n.includes(i.TextStyle.Bold),
            "adv-u-font-italic": null == n ? void 0 : n.includes(i.TextStyle.Italic)
          });
          return (0, o.h)("span", {
            className: r
          }, t);
        };
      },
      273: function _(e, t, n) {
        "use strict";

        var r = this && this.__assign || function () {
          return r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }, r.apply(this, arguments);
        },
            o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = n(400),
            u = o(n(571)),
            l = o(n(995));

        t.default = function (e) {
          var t = e.url,
              n = e.displayText;
          return (0, i.h)(l.default, {
            href: t
          }, n ? (0, i.h)(u.default, r({}, n)) : t);
        };
      },
      629: function _(e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var o = n(400),
            i = r(n(212)),
            u = function () {
          function e(e) {
            if ("object" == _typeof(e) && "nodeType" in e) this.target = e;else try {
              if (this.target = window.document.querySelector(e), !this.target) throw Error("Target element was not found");
            } catch (e) {
              throw Error(e);
            }
          }

          return e.prototype.render = function (e) {
            (0, o.render)((0, o.h)(i.default, {
              document: e
            }), this.target);
          }, e;
        }();

        t.default = u;
      },
      230: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.TextStyle = t.ElementTypes = void 0, function (e) {
          e.Chapter = "chapter", e.Section = "section", e.Paragraph = "paragraph", e.Text = "text", e.Weblink = "weblink", e.List = "list", e.Table = "table", e.InternalReference = "internalReference";
        }(t.ElementTypes || (t.ElementTypes = {})), function (e) {
          e.Bold = "BOLD", e.Italic = "ITALIC";
        }(t.TextStyle || (t.TextStyle = {}));
      },
      578: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getUniqueId = void 0;
        var n = Date.now();

        t.getUniqueId = function (e) {
          return void 0 === e && (e = "id"), n += 1, "".concat(e, "-").concat(n);
        };
      },
      70: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getScrollParent = void 0;

        t.getScrollParent = function (e) {
          var n = e instanceof HTMLElement && window.getComputedStyle(e).overflowY;
          return e ? "visible" !== n && "hidden" !== n ? e : (0, t.getScrollParent)(e.parentNode) || document.body : -1;
        };
      }
    },
        t = {};

    function n(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.exports;
    }

    n.d = function (e, t) {
      for (var r in t) {
        n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = n(629);
    return r = r.default;
  }();
});